//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
export class SituRenderServiceWebApiClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    healthCheck() {
        let url_ = this.baseUrl + "/healthcheck";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processHealthCheck(_response);
        });
    }
    processHealthCheck(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(HealthCheck.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    ping() {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processPing(_response);
        });
    }
    processPing(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomeData(request) {
        let url_ = this.baseUrl + "/api/homes/get-home-data";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomeData(_response);
        });
    }
    processGetHomeData(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomeDataResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomesData(request) {
        let url_ = this.baseUrl + "/api/homes/get-homes-data";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomesData(_response);
        });
    }
    processGetHomesData(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomesDataResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listHomesInQueue(request) {
        let url_ = this.baseUrl + "/api/queues/list-homes-in-queue";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListHomesInQueue(_response);
        });
    }
    processListHomesInQueue(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListHomesInQueueResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    cancelHomeInQueue(request) {
        let url_ = this.baseUrl + "/api/queues/cancel-home-in-queue";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCancelHomeInQueue(_response);
        });
    }
    processCancelHomeInQueue(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CancelHomeInQueueResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getArtifactProgress(request) {
        let url_ = this.baseUrl + "/api/GetArtifactProgress";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetArtifactProgress(_response);
        });
    }
    processGetArtifactProgress(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetArtifactProgressResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getEnvironmentOverride(request) {
        let url_ = this.baseUrl + "/api/queries/GetEnvironmentOverride";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetEnvironmentOverride(_response);
        });
    }
    processGetEnvironmentOverride(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetEnvironmentOverrideResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomeArtifact(request) {
        let url_ = this.baseUrl + "/api/GetHomeArtifact";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomeArtifact(_response);
        });
    }
    processGetHomeArtifact(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomeArtifactResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHome(request) {
        let url_ = this.baseUrl + "/api/GetHome";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHome(_response);
        });
    }
    processGetHome(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomeProgress(request) {
        let url_ = this.baseUrl + "/api/GetHomeProgress";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomeProgress(_response);
        });
    }
    processGetHomeProgress(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomeProgressResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getHomeStatus(request) {
        let url_ = this.baseUrl + "/api/queries/GetHomeStatus";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetHomeStatus(_response);
        });
    }
    processGetHomeStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetHomeStatusResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProductionArtifacts(request) {
        let url_ = this.baseUrl + "/api/queries/GetProductionArtifactsForBuilder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetProductionArtifacts(_response);
        });
    }
    processGetProductionArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProductionArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getQueuedAssetModule(request) {
        let url_ = this.baseUrl + "/api/queries/GetQueuedAssetModule";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetQueuedAssetModule(_response);
        });
    }
    processGetQueuedAssetModule(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetQueuedAssetModuleResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getQueuedGenericArtifact(request) {
        let url_ = this.baseUrl + "/api/queries/GetQueuedGenericArtifact";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetQueuedGenericArtifact(_response);
        });
    }
    processGetQueuedGenericArtifact(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetQueuedGenericArtifactResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getQueuedHome(request) {
        let url_ = this.baseUrl + "/api/queries/GetQueuedHome";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetQueuedHome(_response);
        });
    }
    processGetQueuedHome(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetQueuedHomeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getQueuedSituFacade(request) {
        let url_ = this.baseUrl + "/api/queries/GetQueuedSituFacade";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetQueuedSituFacade(_response);
        });
    }
    processGetQueuedSituFacade(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetQueuedSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getQueuedSituPlan(request) {
        let url_ = this.baseUrl + "/api/queries/GetQueuedSituPlan";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetQueuedSituPlan(_response);
        });
    }
    processGetQueuedSituPlan(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetQueuedSituPlanResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getQueuedSituRender(request) {
        let url_ = this.baseUrl + "/api/queries/GetQueuedSituRender";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetQueuedSituRender(_response);
        });
    }
    processGetQueuedSituRender(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetQueuedSituRenderResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getQueuedSituVanity(request) {
        let url_ = this.baseUrl + "/api/queries/GetQueuedSituVanity";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetQueuedSituVanity(_response);
        });
    }
    processGetQueuedSituVanity(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetQueuedSituVanityResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getRenderReport(request) {
        let url_ = this.baseUrl + "/api/GetRenderReport";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetRenderReport(_response);
        });
    }
    processGetRenderReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRenderReportResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituConnect(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituConnect";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituConnect(_response);
        });
    }
    processGetSituConnect(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituConnectResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituConnectType(situConnectId) {
        let url_ = this.baseUrl + "/api/queries/GetSituConnectType?";
        if (situConnectId === null)
            throw new Error("The parameter 'situConnectId' cannot be null.");
        else if (situConnectId !== undefined)
            url_ += "situConnectId=" + encodeURIComponent("" + situConnectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituConnectType(_response);
        });
    }
    processGetSituConnectType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituFacadeConfig(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituFacadeConfig";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituFacadeConfig(_response);
        });
    }
    processGetSituFacadeConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituFacadeConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituFacade(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituFacade";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituFacade(_response);
        });
    }
    processGetSituFacade(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituFacadeWithConfigNames(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituFacadeWithConfigNames";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituFacadeWithConfigNames(_response);
        });
    }
    processGetSituFacadeWithConfigNames(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituFacadeWithIds(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituFacadeWithIds";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituFacadeWithIds(_response);
        });
    }
    processGetSituFacadeWithIds(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituPlan(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituPlan";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituPlan(_response);
        });
    }
    processGetSituPlan(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituPlanResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituRenderConfig(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituRenderConfig";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituRenderConfig(_response);
        });
    }
    processGetSituRenderConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituRenderConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituRender(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituRender";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituRender(_response);
        });
    }
    processGetSituRender(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituRenderResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituVanity(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituVanity";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituVanity(_response);
        });
    }
    processGetSituVanity(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituVanityResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSituVanityOptionsConfig(request) {
        let url_ = this.baseUrl + "/api/queries/GetSituVanityOptionsConfig";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetSituVanityOptionsConfig(_response);
        });
    }
    processGetSituVanityOptionsConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetSituVanityOptionsConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getStyleChoices(request) {
        let url_ = this.baseUrl + "/api/queries/GetStyleChoices";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetStyleChoices(_response);
        });
    }
    processGetStyleChoices(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetStyleChoicesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listCache(request) {
        let url_ = this.baseUrl + "/api/queries/ListCache";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListCache(_response);
        });
    }
    processListCache(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListCacheResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listEnvironmentsByBuilder(request) {
        let url_ = this.baseUrl + "/api/queries/ListEnvironmentsByBuilder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListEnvironmentsByBuilder(_response);
        });
    }
    processListEnvironmentsByBuilder(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListEnvironmentsByBuilderResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listNextPriorityConfigs(request) {
        let url_ = this.baseUrl + "/api/Queries/ListNextPriorityConfigs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListNextPriorityConfigs(_response);
        });
    }
    processListNextPriorityConfigs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListNextPriorityConfigsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listPriorityConfig(request) {
        let url_ = this.baseUrl + "/api/queries/ListPriorityConfigs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListPriorityConfig(_response);
        });
    }
    processListPriorityConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListPriorityConfigsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listQueuedAssetModules(request) {
        let url_ = this.baseUrl + "/api/queries/ListQueuedAssetModules";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListQueuedAssetModules(_response);
        });
    }
    processListQueuedAssetModules(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListQueuedAssetModulesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listQueuedGenericArtifacts(request) {
        let url_ = this.baseUrl + "/api/queries/ListQueuedGenericArtifacts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListQueuedGenericArtifacts(_response);
        });
    }
    processListQueuedGenericArtifacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListQueuedGenericArtifactsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listQueuedSituFacades(request) {
        let url_ = this.baseUrl + "/api/queries/ListQueuedSituFacades";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListQueuedSituFacades(_response);
        });
    }
    processListQueuedSituFacades(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListQueuedSituFacadesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listQueuedSituPlans(request) {
        let url_ = this.baseUrl + "/api/queries/ListQueuedSituPlans";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListQueuedSituPlans(_response);
        });
    }
    processListQueuedSituPlans(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListQueuedSituPlansResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listQueuedSituRenders(request) {
        let url_ = this.baseUrl + "/api/queries/ListQueuedSituRenders";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListQueuedSituRenders(_response);
        });
    }
    processListQueuedSituRenders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListQueuedSituRendersResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listQueuedSituVanities(request) {
        let url_ = this.baseUrl + "/api/queries/ListQueuedSituVanities";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListQueuedSituVanities(_response);
        });
    }
    processListQueuedSituVanities(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListQueuedSituVanitiesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listRenderedHomesByBuilder(request) {
        let url_ = this.baseUrl + "/api/ListRenderedHomes";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListRenderedHomesByBuilder(_response);
        });
    }
    processListRenderedHomesByBuilder(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListRenderedHomesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listSituFacadeConfigs(request) {
        let url_ = this.baseUrl + "/api/queries/ListSituFacadeConfigs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListSituFacadeConfigs(_response);
        });
    }
    processListSituFacadeConfigs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListSituFacadeConfigsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listSituRenderConfigs(request) {
        let url_ = this.baseUrl + "/api/queries/ListSituRenderConfigs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListSituRenderConfigs(_response);
        });
    }
    processListSituRenderConfigs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListSituRenderConfigsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listSituVanityOptionsConfigs(request) {
        let url_ = this.baseUrl + "/api/queries/ListSituVanityOptionsConfigs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListSituVanityOptionsConfigs(_response);
        });
    }
    processListSituVanityOptionsConfigs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListSituVanityOptionsConfigsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listStyleChoices(request) {
        let url_ = this.baseUrl + "/api/queries/ListStyleChoices";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListStyleChoices(_response);
        });
    }
    processListStyleChoices(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListStyleChoicesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addEnvironmentOverride(request) {
        let url_ = this.baseUrl + "/api/commands/AddEnvironmentOverride";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddEnvironmentOverride(_response);
        });
    }
    processAddEnvironmentOverride(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddEnvironmentOverrideResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addManyPriorityConfigs(request) {
        let url_ = this.baseUrl + "/api/commands/AddManyPriorityConfigs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddManyPriorityConfigs(_response);
        });
    }
    processAddManyPriorityConfigs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddManyPriorityConfigsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addPriorityConfig(request) {
        let url_ = this.baseUrl + "/api/commands/AddPriorityConfig";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddPriorityConfig(_response);
        });
    }
    processAddPriorityConfig(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AddPriorityConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    copySituConnect(request) {
        let url_ = this.baseUrl + "/api/CopySituConnect";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCopySituConnect(_response);
        });
    }
    processCopySituConnect(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CopySituConnectResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createAssetModule(request) {
        let url_ = this.baseUrl + "/api/CreateAssetModule";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateAssetModule(_response);
        });
    }
    processCreateAssetModule(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateAssetModuleResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createGenericArtifact(request) {
        let url_ = this.baseUrl + "/api/CreateGenericArtifact";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateGenericArtifact(_response);
        });
    }
    processCreateGenericArtifact(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateGenericArtifactResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituConnect(dateRequestedFor, companyId, connectProductTypeCode, situConnectId, connectConfigJson, cancelJobIfProductSkuCodesNotFound, environment, notifyCompleteChannel, files) {
        let url_ = this.baseUrl + "/api/CreateSituConnect";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (dateRequestedFor !== null && dateRequestedFor !== undefined)
            content_.append("DateRequestedFor", dateRequestedFor.toJSON());
        if (companyId === null || companyId === undefined)
            throw new Error("The parameter 'companyId' cannot be null.");
        else
            content_.append("CompanyId", companyId.toString());
        if (connectProductTypeCode !== null && connectProductTypeCode !== undefined)
            content_.append("ConnectProductTypeCode", connectProductTypeCode.toString());
        if (situConnectId !== null && situConnectId !== undefined)
            content_.append("SituConnectId", situConnectId.toString());
        if (connectConfigJson !== null && connectConfigJson !== undefined)
            content_.append("ConnectConfigJson", connectConfigJson.toString());
        if (cancelJobIfProductSkuCodesNotFound === null || cancelJobIfProductSkuCodesNotFound === undefined)
            throw new Error("The parameter 'cancelJobIfProductSkuCodesNotFound' cannot be null.");
        else
            content_.append("CancelJobIfProductSkuCodesNotFound", cancelJobIfProductSkuCodesNotFound.toString());
        if (environment !== null && environment !== undefined)
            content_.append("Environment", environment.toString());
        if (notifyCompleteChannel !== null && notifyCompleteChannel !== undefined)
            content_.append("NotifyCompleteChannel", notifyCompleteChannel.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituConnect(_response);
        });
    }
    processCreateSituConnect(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateSituConnectResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituFacade(request, forcePreRenderQueue) {
        let url_ = this.baseUrl + "/api/CreateSituFacade?";
        if (forcePreRenderQueue === null)
            throw new Error("The parameter 'forcePreRenderQueue' cannot be null.");
        else if (forcePreRenderQueue !== undefined)
            url_ += "forcePreRenderQueue=" + encodeURIComponent("" + forcePreRenderQueue) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituFacade(_response);
        });
    }
    processCreateSituFacade(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituFacadeWithConfigNames(request, forcePreRenderQueue) {
        let url_ = this.baseUrl + "/api/CreateSituFacadeWithConfigNames?";
        if (forcePreRenderQueue === null)
            throw new Error("The parameter 'forcePreRenderQueue' cannot be null.");
        else if (forcePreRenderQueue !== undefined)
            url_ += "forcePreRenderQueue=" + encodeURIComponent("" + forcePreRenderQueue) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituFacadeWithConfigNames(_response);
        });
    }
    processCreateSituFacadeWithConfigNames(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituFacadeWithIds(request, forcePreRenderQueue) {
        let url_ = this.baseUrl + "/api/CreateSituFacadeWithIds?";
        if (forcePreRenderQueue === null)
            throw new Error("The parameter 'forcePreRenderQueue' cannot be null.");
        else if (forcePreRenderQueue !== undefined)
            url_ += "forcePreRenderQueue=" + encodeURIComponent("" + forcePreRenderQueue) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituFacadeWithIds(_response);
        });
    }
    processCreateSituFacadeWithIds(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateSituFacadeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituPlan(request, forcePreRenderQueue) {
        let url_ = this.baseUrl + "/api/CreateSituPlan?";
        if (forcePreRenderQueue === null)
            throw new Error("The parameter 'forcePreRenderQueue' cannot be null.");
        else if (forcePreRenderQueue !== undefined)
            url_ += "forcePreRenderQueue=" + encodeURIComponent("" + forcePreRenderQueue) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituPlan(_response);
        });
    }
    processCreateSituPlan(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateSituPlanResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituRender(request, forcePreRenderQueue) {
        let url_ = this.baseUrl + "/api/CreateSituRender?";
        if (forcePreRenderQueue === null)
            throw new Error("The parameter 'forcePreRenderQueue' cannot be null.");
        else if (forcePreRenderQueue !== undefined)
            url_ += "forcePreRenderQueue=" + encodeURIComponent("" + forcePreRenderQueue) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituRender(_response);
        });
    }
    processCreateSituRender(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateSituRenderResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSituVanity(request, forcePreRenderQueue) {
        let url_ = this.baseUrl + "/api/CreateSituVanity?";
        if (forcePreRenderQueue === null)
            throw new Error("The parameter 'forcePreRenderQueue' cannot be null.");
        else if (forcePreRenderQueue !== undefined)
            url_ += "forcePreRenderQueue=" + encodeURIComponent("" + forcePreRenderQueue) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateSituVanity(_response);
        });
    }
    processCreateSituVanity(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreateSituVanityResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deleteEnvironmentOverride(request) {
        let url_ = this.baseUrl + "/api/commands/DeleteEnvironmentOverride";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteEnvironmentOverride(_response);
        });
    }
    processDeleteEnvironmentOverride(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeleteEnvironmentOverrideResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    downloadSituFacades(request) {
        let url_ = this.baseUrl + "/api/commands/DownloadSituFacades";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDownloadSituFacades(_response);
        });
    }
    processDownloadSituFacades(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    purgeCache(request) {
        let url_ = this.baseUrl + "/api/commands/PurgeCache";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processPurgeCache(_response);
        });
    }
    processPurgeCache(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurgeCacheResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    removeManyPriorityConfigs(request) {
        let url_ = this.baseUrl + "/api/commands/RemoveManyPriorityConfigs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRemoveManyPriorityConfigs(_response);
        });
    }
    processRemoveManyPriorityConfigs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RemoveManyPriorityConfigResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    reorderPriorityConfigs(request) {
        let url_ = this.baseUrl + "/api/commands/ReorderPriorityConfigs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processReorderPriorityConfigs(_response);
        });
    }
    processReorderPriorityConfigs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReorderPriorityConfigsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saveEnvironmentsForBuilder(request) {
        let url_ = this.baseUrl + "/api/queries/SaveEnvironmentsForBuilder";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSaveEnvironmentsForBuilder(_response);
        });
    }
    processSaveEnvironmentsForBuilder(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SaveEnvironmentsForBuilderResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    saveRenderError(request) {
        let url_ = this.baseUrl + "/api/commands/SaveRenderError";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSaveRenderError(_response);
        });
    }
    processSaveRenderError(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    setArtifactAsProduction(request) {
        let url_ = this.baseUrl + "/api/commands/SetArtifactAsProduction";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetArtifactAsProduction(_response);
        });
    }
    processSetArtifactAsProduction(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SetArtifactAsProductionResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    setPriorityConfigStatus(request) {
        let url_ = this.baseUrl + "/api/commands/SetPriorityConfigStatus";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSetPriorityConfigStatus(_response);
        });
    }
    processSetPriorityConfigStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SetPriorityConfigStatusResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateEnvironmentOverride(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateEnvironmentOverride";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateEnvironmentOverride(_response);
        });
    }
    processUpdateEnvironmentOverride(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateEnvironmentOverrideResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class HealthCheck {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.service = _data["service"];
            this.status = _data["status"];
            this.reason = _data["reason"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheck();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["status"] = this.status;
        data["reason"] = this.reason;
        return data;
    }
}
export class SituResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class GetHomeDataResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.homeConfig = _data["homeConfig"] ? HomeConfigSummary.fromJS(_data["homeConfig"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeDataResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class HomeConfigSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeConfigId = _data["homeConfigId"];
            this.artifactId = _data["artifactId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            this.status = _data["status"];
            this.positionInQueue = _data["positionInQueue"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HomeConfigSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigId"] = this.homeConfigId;
        data["artifactId"] = this.artifactId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["status"] = this.status;
        data["positionInQueue"] = this.positionInQueue;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        return data;
    }
}
export class HomeConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
            this.home = _data["home"];
            this.masterFile = _data["masterFile"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (let item of _data["options"])
                    this.options.push(item);
            }
            if (Array.isArray(_data["themes"])) {
                this.themes = [];
                for (let item of _data["themes"])
                    this.themes.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HomeConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["home"] = this.home;
        data["masterFile"] = this.masterFile;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item);
        }
        return data;
    }
}
export var HomeStatus;
(function (HomeStatus) {
    HomeStatus[HomeStatus["Complete"] = 0] = "Complete";
    HomeStatus[HomeStatus["Queued"] = 1] = "Queued";
    HomeStatus[HomeStatus["NotAvailable"] = 2] = "NotAvailable";
    HomeStatus[HomeStatus["InProgress"] = 3] = "InProgress";
    HomeStatus[HomeStatus["Failed"] = 4] = "Failed";
})(HomeStatus || (HomeStatus = {}));
export class GetHomeDataRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeConfigId = _data["homeConfigId"];
            this.environmentName = _data["environmentName"];
            this.renderType = _data["renderType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeDataRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigId"] = this.homeConfigId;
        data["environmentName"] = this.environmentName;
        data["renderType"] = this.renderType;
        return data;
    }
}
export var EnvironmentName;
(function (EnvironmentName) {
    EnvironmentName[EnvironmentName["Latest"] = 0] = "Latest";
    EnvironmentName[EnvironmentName["Staging"] = 1] = "Staging";
    EnvironmentName[EnvironmentName["Production"] = 2] = "Production";
    EnvironmentName[EnvironmentName["Fallback"] = 3] = "Fallback";
})(EnvironmentName || (EnvironmentName = {}));
export var RenderType;
(function (RenderType) {
    RenderType[RenderType["Rasterized"] = 0] = "Rasterized";
    RenderType[RenderType["PathTraced"] = 1] = "PathTraced";
    RenderType[RenderType["BestAvailable"] = 2] = "BestAvailable";
    RenderType[RenderType["VirtualReality"] = 3] = "VirtualReality";
    RenderType[RenderType["SituRender"] = 4] = "SituRender";
    RenderType[RenderType["Facade"] = 5] = "Facade";
    RenderType[RenderType["SituPlan"] = 6] = "SituPlan";
    RenderType[RenderType["Insights"] = 7] = "Insights";
    RenderType[RenderType["Vanity"] = 8] = "Vanity";
    RenderType[RenderType["AssetModule"] = 9] = "AssetModule";
    RenderType[RenderType["GenericArtifact"] = 10] = "GenericArtifact";
    RenderType[RenderType["PathTracedPlus"] = 11] = "PathTracedPlus";
    RenderType[RenderType["Connect"] = 12] = "Connect";
    RenderType[RenderType["ProductPreview"] = 13] = "ProductPreview";
    RenderType[RenderType["IfcPreview"] = 14] = "IfcPreview";
    RenderType[RenderType["Unreal"] = 15] = "Unreal";
})(RenderType || (RenderType = {}));
export class GetHomesDataResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["homeConfigs"])) {
                this.homeConfigs = [];
                for (let item of _data["homeConfigs"])
                    this.homeConfigs.push(HomeConfigSummary.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomesDataResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.homeConfigs)) {
            data["homeConfigs"] = [];
            for (let item of this.homeConfigs)
                data["homeConfigs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class GetHomesDataRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
            this.environmentName = _data["environmentName"];
            this.renderType = _data["renderType"];
            if (Array.isArray(_data["homes"])) {
                this.homes = [];
                for (let item of _data["homes"])
                    this.homes.push(HomeConfig.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomesDataRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["environmentName"] = this.environmentName;
        data["renderType"] = this.renderType;
        if (Array.isArray(this.homes)) {
            data["homes"] = [];
            for (let item of this.homes)
                data["homes"].push(item.toJSON());
        }
        return data;
    }
}
export class ListHomesInQueueResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["homeConfigs"])) {
                this.homeConfigs = [];
                for (let item of _data["homeConfigs"])
                    this.homeConfigs.push(HomeConfigSummary.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListHomesInQueueResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.homeConfigs)) {
            data["homeConfigs"] = [];
            for (let item of this.homeConfigs)
                data["homeConfigs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListHomesInQueueRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
            this.environmentName = _data["environmentName"];
            this.renderType = _data["renderType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListHomesInQueueRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["environmentName"] = this.environmentName;
        data["renderType"] = this.renderType;
        return data;
    }
}
export class CancelHomeInQueueResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CancelHomeInQueueResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class CancelHomeInQueueRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeConfigId = _data["homeConfigId"];
            this.artifactId = _data["artifactId"];
            this.environmentName = _data["environmentName"];
            this.renderType = _data["renderType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CancelHomeInQueueRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigId"] = this.homeConfigId;
        data["artifactId"] = this.artifactId;
        data["environmentName"] = this.environmentName;
        data["renderType"] = this.renderType;
        return data;
    }
}
export class GetArtifactProgressResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.homeConfigDetails = _data["homeConfigDetails"] ? HomeConfigDetails.fromJS(_data["homeConfigDetails"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtifactProgressResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigDetails"] = this.homeConfigDetails ? this.homeConfigDetails.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class HomeConfigDetails extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.homeConfigId = _data["homeConfigId"];
            this.recipeFingerprint = _data["recipeFingerprint"];
            this.estimatedCompletionTime = _data["estimatedCompletionTime"] ? new Date(_data["estimatedCompletionTime"].toString()) : undefined;
            this.expectedNumberOfFiles = _data["expectedNumberOfFiles"];
            this.positionInQueue = _data["positionInQueue"];
            if (Array.isArray(_data["files"])) {
                this.files = [];
                for (let item of _data["files"])
                    this.files.push(HomeConfigFile.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HomeConfigDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["homeConfigId"] = this.homeConfigId;
        data["recipeFingerprint"] = this.recipeFingerprint;
        data["estimatedCompletionTime"] = this.estimatedCompletionTime ? this.estimatedCompletionTime.toISOString() : undefined;
        data["expectedNumberOfFiles"] = this.expectedNumberOfFiles;
        data["positionInQueue"] = this.positionInQueue;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class HomeConfigFile {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.homeConfigId = _data["homeConfigId"];
            this.fileName = _data["fileName"];
            this.url = _data["url"];
            this.type = _data["type"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HomeConfigFile();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["homeConfigId"] = this.homeConfigId;
        data["fileName"] = this.fileName;
        data["url"] = this.url;
        data["type"] = this.type;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        return data;
    }
}
export var HomeConfigFileType;
(function (HomeConfigFileType) {
    HomeConfigFileType[HomeConfigFileType["FixtureData"] = 0] = "FixtureData";
    HomeConfigFileType[HomeConfigFileType["FloorPlan"] = 1] = "FloorPlan";
    HomeConfigFileType[HomeConfigFileType["Fixture"] = 2] = "Fixture";
    HomeConfigFileType[HomeConfigFileType["Panorama"] = 3] = "Panorama";
})(HomeConfigFileType || (HomeConfigFileType = {}));
export class GetArtifactProgressRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetArtifactProgressRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        return data;
    }
}
export class GetEnvironmentOverrideResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.environmentOverride = _data["environmentOverride"] ? EnvironmentOverride.fromJS(_data["environmentOverride"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetEnvironmentOverrideResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environmentOverride"] = this.environmentOverride ? this.environmentOverride.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class EnvironmentOverride {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.warpEnvironmentId = _data["warpEnvironmentId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentOverride();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["warpEnvironmentId"] = this.warpEnvironmentId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        return data;
    }
}
export class GetEnvironmentOverrideRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.environmentOverrideId = _data["environmentOverrideId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetEnvironmentOverrideRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environmentOverrideId"] = this.environmentOverrideId;
        return data;
    }
}
export class GetHomeArtifactResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeArtifactResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        super.toJSON(data);
        return data;
    }
}
export class GetHomeArtifactRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeConfigId = _data["homeConfigId"];
            this.recipeFingerprint = _data["recipeFingerprint"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeArtifactRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigId"] = this.homeConfigId;
        data["recipeFingerprint"] = this.recipeFingerprint;
        return data;
    }
}
export class GetHomeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.homeConfigDetails = _data["homeConfigDetails"] ? HomeConfigDetails.fromJS(_data["homeConfigDetails"]) : undefined;
            this.artifactId = _data["artifactId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigDetails"] = this.homeConfigDetails ? this.homeConfigDetails.toJSON() : undefined;
        data["artifactId"] = this.artifactId;
        super.toJSON(data);
        return data;
    }
}
export class GetHomeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeId = _data["homeId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            this.forceRefresh = _data["forceRefresh"];
            this.startingRoom = _data["startingRoom"];
            this.preCache = _data["preCache"];
            this.renderType = _data["renderType"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.artifactId = _data["artifactId"];
            this.artifactEnvironment = _data["artifactEnvironment"] ? ArtifactEnvironment.fromJS(_data["artifactEnvironment"]) : undefined;
            this.queueName = _data["queueName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeId"] = this.homeId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["forceRefresh"] = this.forceRefresh;
        data["startingRoom"] = this.startingRoom;
        data["preCache"] = this.preCache;
        data["renderType"] = this.renderType;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["artifactId"] = this.artifactId;
        data["artifactEnvironment"] = this.artifactEnvironment ? this.artifactEnvironment.toJSON() : undefined;
        data["queueName"] = this.queueName;
        return data;
    }
}
export class ArtifactEnvironment {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.company = _data["company"];
            this.environment = _data["environment"];
            this.product = _data["product"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactEnvironment();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["environment"] = this.environment;
        data["product"] = this.product;
        return data;
    }
}
export var ProductName;
(function (ProductName) {
    ProductName[ProductName["Panorama"] = 0] = "Panorama";
    ProductName[ProductName["VR"] = 1] = "VR";
    ProductName[ProductName["RayTraced"] = 2] = "RayTraced";
    ProductName[ProductName["Plan"] = 3] = "Plan";
    ProductName[ProductName["Render"] = 4] = "Render";
    ProductName[ProductName["Facade"] = 5] = "Facade";
    ProductName[ProductName["Insights"] = 6] = "Insights";
    ProductName[ProductName["Vanity"] = 7] = "Vanity";
    ProductName[ProductName["AssetModule"] = 8] = "AssetModule";
    ProductName[ProductName["RayTracedPlus"] = 9] = "RayTracedPlus";
    ProductName[ProductName["ProductPreview"] = 10] = "ProductPreview";
    ProductName[ProductName["IfcPreview"] = 11] = "IfcPreview";
    ProductName[ProductName["Connect"] = 12] = "Connect";
    ProductName[ProductName["Unreal"] = 13] = "Unreal";
})(ProductName || (ProductName = {}));
export class GetHomeProgressResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.homeConfigDetails = _data["homeConfigDetails"] ? HomeConfigDetails.fromJS(_data["homeConfigDetails"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeProgressResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigDetails"] = this.homeConfigDetails ? this.homeConfigDetails.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetHomeProgressRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeConfigId = _data["homeConfigId"];
            this.recipeFingerprint = _data["recipeFingerprint"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeProgressRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigId"] = this.homeConfigId;
        data["recipeFingerprint"] = this.recipeFingerprint;
        return data;
    }
}
export class GetHomeStatusResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedHome = _data["queuedHome"] ? HomeConfigSummary.fromJS(_data["queuedHome"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeStatusResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedHome"] = this.queuedHome ? this.queuedHome.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetHomeStatusRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.renderType = _data["renderType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetHomeStatusRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["renderType"] = this.renderType;
        return data;
    }
}
export class GetProductionArtifactsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["artifacts"])) {
                this.artifacts = [];
                for (let item of _data["artifacts"])
                    this.artifacts.push(ArtifactVersion.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductionArtifactsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.artifacts)) {
            data["artifacts"] = [];
            for (let item of this.artifacts)
                data["artifacts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ArtifactVersion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactVersion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        return data;
    }
}
export class GetProductionArtifactsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
            this.product = _data["product"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductionArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["product"] = this.product;
        return data;
    }
}
export class GetQueuedAssetModuleResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedAssetModule = _data["queuedAssetModule"] ? QueuedAssetModule.fromJS(_data["queuedAssetModule"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedAssetModuleResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedAssetModule"] = this.queuedAssetModule ? this.queuedAssetModule.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class QueuedAssetModule {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.companyCode = _data["companyCode"];
            this.assetModuleName = _data["assetModuleName"];
            this.status = _data["status"];
            this.positionInQueue = _data["positionInQueue"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueuedAssetModule();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["companyCode"] = this.companyCode;
        data["assetModuleName"] = this.assetModuleName;
        data["status"] = this.status;
        data["positionInQueue"] = this.positionInQueue;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        return data;
    }
}
export class GetQueuedAssetModuleRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.assetModuleId = _data["assetModuleId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedAssetModuleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["assetModuleId"] = this.assetModuleId;
        return data;
    }
}
export class GetQueuedGenericArtifactResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedGenericArtifact = _data["queuedGenericArtifact"] ? QueuedGenericArtifact.fromJS(_data["queuedGenericArtifact"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedGenericArtifactResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedGenericArtifact"] = this.queuedGenericArtifact ? this.queuedGenericArtifact.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class QueuedGenericArtifact {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.companyCode = _data["companyCode"];
            this.genericArtifactName = _data["genericArtifactName"];
            this.status = _data["status"];
            this.positionInQueue = _data["positionInQueue"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueuedGenericArtifact();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["companyCode"] = this.companyCode;
        data["genericArtifactName"] = this.genericArtifactName;
        data["status"] = this.status;
        data["positionInQueue"] = this.positionInQueue;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        return data;
    }
}
export class GetQueuedGenericArtifactRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.genericArtifactId = _data["genericArtifactId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedGenericArtifactRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["genericArtifactId"] = this.genericArtifactId;
        return data;
    }
}
export class GetQueuedHomeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedHome = _data["queuedHome"] ? HomeConfigSummary.fromJS(_data["queuedHome"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedHomeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedHome"] = this.queuedHome ? this.queuedHome.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetQueuedHomeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.renderType = _data["renderType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedHomeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["renderType"] = this.renderType;
        return data;
    }
}
export class GetQueuedSituFacadeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedSituFacade = _data["queuedSituFacade"] ? QueuedSituFacade.fromJS(_data["queuedSituFacade"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedSituFacadeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedSituFacade"] = this.queuedSituFacade ? this.queuedSituFacade.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class QueuedSituFacade {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            this.dollyPercent = _data["dollyPercent"];
            this.focalPercent = _data["focalPercent"];
            if (Array.isArray(_data["styleChoices"])) {
                this.styleChoices = [];
                for (let item of _data["styleChoices"])
                    this.styleChoices.push(StyleChoice.fromJS(item));
            }
            this.status = _data["status"];
            this.positionInQueue = _data["positionInQueue"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.homeConfigId = _data["homeConfigId"];
            this.facadeConfigName = _data["facadeConfigName"];
            this.styleChoicesConfigName = _data["styleChoicesConfigName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueuedSituFacade();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["dollyPercent"] = this.dollyPercent;
        data["focalPercent"] = this.focalPercent;
        if (Array.isArray(this.styleChoices)) {
            data["styleChoices"] = [];
            for (let item of this.styleChoices)
                data["styleChoices"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["positionInQueue"] = this.positionInQueue;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["homeConfigId"] = this.homeConfigId;
        data["facadeConfigName"] = this.facadeConfigName;
        data["styleChoicesConfigName"] = this.styleChoicesConfigName;
        return data;
    }
}
export class StyleChoice {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.choice = _data["choice"] ? StyleChoice.fromJS(_data["choice"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleChoice();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["choice"] = this.choice ? this.choice.toJSON() : undefined;
        return data;
    }
}
export class GetQueuedSituFacadeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situFacadeId = _data["situFacadeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedSituFacadeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situFacadeId"] = this.situFacadeId;
        return data;
    }
}
export class GetQueuedSituPlanResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedSituPlan = _data["queuedSituPlan"] ? QueuedSituPlan.fromJS(_data["queuedSituPlan"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedSituPlanResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedSituPlan"] = this.queuedSituPlan ? this.queuedSituPlan.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class QueuedSituPlan {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            this.status = _data["status"];
            this.positionInQueue = _data["positionInQueue"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueuedSituPlan();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["status"] = this.status;
        data["positionInQueue"] = this.positionInQueue;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        return data;
    }
}
export class GetQueuedSituPlanRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situPlanId = _data["situPlanId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedSituPlanRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situPlanId"] = this.situPlanId;
        return data;
    }
}
export class GetQueuedSituRenderResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedSituRender = _data["queuedSituRender"] ? QueuedSituRender.fromJS(_data["queuedSituRender"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedSituRenderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedSituRender"] = this.queuedSituRender ? this.queuedSituRender.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class QueuedSituRender {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            if (Array.isArray(_data["photos"])) {
                this.photos = [];
                for (let item of _data["photos"])
                    this.photos.push(SituRenderPhoto.fromJS(item));
            }
            this.status = _data["status"];
            this.positionInQueue = _data["positionInQueue"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueuedSituRender();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["positionInQueue"] = this.positionInQueue;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        return data;
    }
}
export class SituRenderPhoto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.lookFrom = _data["lookFrom"] ? SituRenderPosition.fromJS(_data["lookFrom"]) : undefined;
            this.lookAt = _data["lookAt"] ? SituRenderPosition.fromJS(_data["lookAt"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituRenderPhoto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lookFrom"] = this.lookFrom ? this.lookFrom.toJSON() : undefined;
        data["lookAt"] = this.lookAt ? this.lookAt.toJSON() : undefined;
        return data;
    }
}
export class SituRenderPosition {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.roomName = _data["roomName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituRenderPosition();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["roomName"] = this.roomName;
        return data;
    }
}
export class GetQueuedSituRenderRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situRenderId = _data["situRenderId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedSituRenderRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situRenderId"] = this.situRenderId;
        return data;
    }
}
export class GetQueuedSituVanityResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedSituVanity = _data["queuedSituVanity"] ? QueuedSituVanity.fromJS(_data["queuedSituVanity"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedSituVanityResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedSituVanity"] = this.queuedSituVanity ? this.queuedSituVanity.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class QueuedSituVanity {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.companyCode = _data["companyCode"];
            this.vanityConfig = _data["vanityConfig"];
            this.vanityTheme = _data["vanityTheme"];
            this.vanityOptionsConfig = _data["vanityOptionsConfig"] ? VanityOptionsConfig.fromJS(_data["vanityOptionsConfig"]) : undefined;
            this.status = _data["status"];
            this.positionInQueue = _data["positionInQueue"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [];
                for (let item of _data["files"])
                    this.files.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueuedSituVanity();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["companyCode"] = this.companyCode;
        data["vanityConfig"] = this.vanityConfig;
        data["vanityTheme"] = this.vanityTheme;
        data["vanityOptionsConfig"] = this.vanityOptionsConfig ? this.vanityOptionsConfig.toJSON() : undefined;
        data["status"] = this.status;
        data["positionInQueue"] = this.positionInQueue;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        return data;
    }
}
export class VanityOptionsConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fingerPrint = _data["fingerPrint"];
            this.benchtopTheme = _data["benchtopTheme"];
            this.benchtopThickness = _data["benchtopThickness"];
            this.basinMaker = _data["basinMaker"];
            this.basinModel = _data["basinModel"];
            this.basinPosition = _data["basinPosition"];
            this.tapMaker = _data["tapMaker"];
            this.tapModel = _data["tapModel"];
            this.tapPosition = _data["tapPosition"];
            this.handlesMaker = _data["handlesMaker"];
            this.handlesModel = _data["handlesModel"];
            this.handlesFingerPull = _data["handlesFingerPull"];
            this.legMaker = _data["legMaker"];
            this.legModel = _data["legModel"];
            this.imageSet = _data["imageSet"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new VanityOptionsConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fingerPrint"] = this.fingerPrint;
        data["benchtopTheme"] = this.benchtopTheme;
        data["benchtopThickness"] = this.benchtopThickness;
        data["basinMaker"] = this.basinMaker;
        data["basinModel"] = this.basinModel;
        data["basinPosition"] = this.basinPosition;
        data["tapMaker"] = this.tapMaker;
        data["tapModel"] = this.tapModel;
        data["tapPosition"] = this.tapPosition;
        data["handlesMaker"] = this.handlesMaker;
        data["handlesModel"] = this.handlesModel;
        data["handlesFingerPull"] = this.handlesFingerPull;
        data["legMaker"] = this.legMaker;
        data["legModel"] = this.legModel;
        data["imageSet"] = this.imageSet;
        return data;
    }
}
export var BasinPosition;
(function (BasinPosition) {
    BasinPosition[BasinPosition["Centre"] = 0] = "Centre";
    BasinPosition[BasinPosition["Left"] = 1] = "Left";
    BasinPosition[BasinPosition["Right"] = 2] = "Right";
    BasinPosition[BasinPosition["Double"] = 3] = "Double";
})(BasinPosition || (BasinPosition = {}));
export var TapPosition;
(function (TapPosition) {
    TapPosition[TapPosition["Left"] = 0] = "Left";
    TapPosition[TapPosition["Centre"] = 1] = "Centre";
    TapPosition[TapPosition["Right"] = 2] = "Right";
    TapPosition[TapPosition["Outside"] = 3] = "Outside";
    TapPosition[TapPosition["Inside"] = 4] = "Inside";
})(TapPosition || (TapPosition = {}));
export var ImageSet;
(function (ImageSet) {
    ImageSet[ImageSet["Everything"] = 0] = "Everything";
    ImageSet[ImageSet["Thumb"] = 1] = "Thumb";
    ImageSet[ImageSet["Single"] = 2] = "Single";
    ImageSet[ImageSet["ExtraAngles"] = 3] = "ExtraAngles";
    ImageSet[ImageSet["Video"] = 4] = "Video";
    ImageSet[ImageSet["Sequence"] = 5] = "Sequence";
})(ImageSet || (ImageSet = {}));
export class GetQueuedSituVanityRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situVanityId = _data["situVanityId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetQueuedSituVanityRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situVanityId"] = this.situVanityId;
        return data;
    }
}
export class GetRenderReportResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.label = _data["label"];
            if (_data["data"]) {
                this.data = {};
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data[key] = _data["data"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRenderReportResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}
export class GetRenderReportRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.type = _data["type"];
            this.productName = _data["productName"];
            this.timePeriod = _data["timePeriod"];
            this.home = _data["home"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetRenderReportRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["type"] = this.type;
        data["productName"] = this.productName;
        data["timePeriod"] = this.timePeriod;
        data["home"] = this.home;
        return data;
    }
}
export var RenderReportType;
(function (RenderReportType) {
    RenderReportType[RenderReportType["DailyRenderAvgByProduct"] = 0] = "DailyRenderAvgByProduct";
    RenderReportType[RenderReportType["DailyRenderAvgByRenderer"] = 1] = "DailyRenderAvgByRenderer";
    RenderReportType[RenderReportType["Last5Renders"] = 2] = "Last5Renders";
    RenderReportType[RenderReportType["Last5RendersHomes"] = 3] = "Last5RendersHomes";
})(RenderReportType || (RenderReportType = {}));
export class GetSituConnectResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedSituConnect = _data["queuedSituConnect"] ? QueuedSituConnect.fromJS(_data["queuedSituConnect"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituConnectResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedSituConnect"] = this.queuedSituConnect ? this.queuedSituConnect.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class QueuedSituConnect {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.situConnectId = _data["situConnectId"];
            this.companyCode = _data["companyCode"];
            this.status = _data["status"];
            this.positionInQueue = _data["positionInQueue"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.connectType = _data["connectType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueuedSituConnect();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["situConnectId"] = this.situConnectId;
        data["companyCode"] = this.companyCode;
        data["status"] = this.status;
        data["positionInQueue"] = this.positionInQueue;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["connectType"] = this.connectType;
        return data;
    }
}
export class GetSituConnectRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situConnectId = _data["situConnectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituConnectRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situConnectId"] = this.situConnectId;
        return data;
    }
}
export class GetSituFacadeConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.dollyPercent = _data["dollyPercent"];
            this.focalPercent = _data["focalPercent"];
            this.imageWidth = _data["imageWidth"];
            this.imageHeight = _data["imageHeight"];
            this.imageQuality = _data["imageQuality"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituFacadeConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dollyPercent"] = this.dollyPercent;
        data["focalPercent"] = this.focalPercent;
        data["imageWidth"] = this.imageWidth;
        data["imageHeight"] = this.imageHeight;
        data["imageQuality"] = this.imageQuality;
        super.toJSON(data);
        return data;
    }
}
export class GetSituFacadeConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.facadeConfigName = _data["facadeConfigName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituFacadeConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["facadeConfigName"] = this.facadeConfigName;
        return data;
    }
}
export class GetSituFacadeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedSituFacade = _data["queuedSituFacade"] ? QueuedSituFacade.fromJS(_data["queuedSituFacade"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituFacadeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedSituFacade"] = this.queuedSituFacade ? this.queuedSituFacade.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetSituFacadeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situFacadeId = _data["situFacadeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituFacadeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situFacadeId"] = this.situFacadeId;
        return data;
    }
}
export class GetSituFacadeWithConfigNamesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            this.facadeConfigName = _data["facadeConfigName"];
            this.styleChoicesConfigName = _data["styleChoicesConfigName"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.companyId = _data["companyId"];
            this.environment = _data["environment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituFacadeWithConfigNamesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["facadeConfigName"] = this.facadeConfigName;
        data["styleChoicesConfigName"] = this.styleChoicesConfigName;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["companyId"] = this.companyId;
        data["environment"] = this.environment;
        return data;
    }
}
export class GetSituFacadeWithIdsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.homeConfigId = _data["homeConfigId"];
            this.facadeConfigName = _data["facadeConfigName"];
            this.styleChoicesConfigName = _data["styleChoicesConfigName"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.companyId = _data["companyId"];
            this.environment = _data["environment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituFacadeWithIdsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["homeConfigId"] = this.homeConfigId;
        data["facadeConfigName"] = this.facadeConfigName;
        data["styleChoicesConfigName"] = this.styleChoicesConfigName;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["companyId"] = this.companyId;
        data["environment"] = this.environment;
        return data;
    }
}
export class GetSituPlanResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedSituPlan = _data["queuedSituPlan"] ? QueuedSituPlan.fromJS(_data["queuedSituPlan"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituPlanResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedSituPlan"] = this.queuedSituPlan ? this.queuedSituPlan.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetSituPlanRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situPlanId = _data["situPlanId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituPlanRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situPlanId"] = this.situPlanId;
        return data;
    }
}
export class GetSituRenderConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["photos"])) {
                this.photos = [];
                for (let item of _data["photos"])
                    this.photos.push(SituRenderPhoto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituRenderConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class GetSituRenderConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fingerPrint = _data["fingerPrint"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituRenderConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fingerPrint"] = this.fingerPrint;
        return data;
    }
}
export class GetSituRenderResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedSituRender = _data["queuedSituRender"] ? QueuedSituRender.fromJS(_data["queuedSituRender"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituRenderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedSituRender"] = this.queuedSituRender ? this.queuedSituRender.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetSituRenderRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situRenderId = _data["situRenderId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituRenderRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situRenderId"] = this.situRenderId;
        return data;
    }
}
export class GetSituVanityResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.queuedSituVanity = _data["queuedSituVanity"] ? QueuedSituVanity.fromJS(_data["queuedSituVanity"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituVanityResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["queuedSituVanity"] = this.queuedSituVanity ? this.queuedSituVanity.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetSituVanityRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situVanityId = _data["situVanityId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituVanityRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situVanityId"] = this.situVanityId;
        return data;
    }
}
export class GetSituVanityOptionsConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.vanityOptionsConfig = _data["vanityOptionsConfig"] ? VanityOptionsConfig.fromJS(_data["vanityOptionsConfig"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituVanityOptionsConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["vanityOptionsConfig"] = this.vanityOptionsConfig ? this.vanityOptionsConfig.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class GetSituVanityOptionsConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fingerPrint = _data["fingerPrint"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSituVanityOptionsConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fingerPrint"] = this.fingerPrint;
        return data;
    }
}
export class GetStyleChoicesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["styleChoices"])) {
                this.styleChoices = [];
                for (let item of _data["styleChoices"])
                    this.styleChoices.push(StyleChoice.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleChoicesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.styleChoices)) {
            data["styleChoices"] = [];
            for (let item of this.styleChoices)
                data["styleChoices"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class GetStyleChoicesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.styleChoicesConfigName = _data["styleChoicesConfigName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStyleChoicesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["styleChoicesConfigName"] = this.styleChoicesConfigName;
        return data;
    }
}
export class ListCacheResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["cacheKeys"])) {
                this.cacheKeys = [];
                for (let item of _data["cacheKeys"])
                    this.cacheKeys.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListCacheResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cacheKeys)) {
            data["cacheKeys"] = [];
            for (let item of this.cacheKeys)
                data["cacheKeys"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}
export class ListCacheRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.keyPrefix = _data["keyPrefix"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListCacheRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keyPrefix"] = this.keyPrefix;
        return data;
    }
}
export class ListEnvironmentsByBuilderResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["environments"])) {
                this.environments = [];
                for (let item of _data["environments"])
                    this.environments.push(EnvironmentSettings.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListEnvironmentsByBuilderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.environments)) {
            data["environments"] = [];
            for (let item of this.environments)
                data["environments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class EnvironmentSettings {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.environment = _data["environment"] ? ArtifactEnvironment.fromJS(_data["environment"]) : undefined;
            this.defaultCuttoffDate = _data["defaultCuttoffDate"] ? new Date(_data["defaultCuttoffDate"].toString()) : undefined;
            if (Array.isArray(_data["referenceKeyCuttoffs"])) {
                this.referenceKeyCuttoffs = [];
                for (let item of _data["referenceKeyCuttoffs"])
                    this.referenceKeyCuttoffs.push(ReferenceKeyCuttoff.fromJS(item));
            }
            if (Array.isArray(_data["overrides"])) {
                this.overrides = [];
                for (let item of _data["overrides"])
                    this.overrides.push(ArtifactVersion.fromJS(item));
            }
            this.retainedFromProductionDate = _data["retainedFromProductionDate"] ? new Date(_data["retainedFromProductionDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentSettings();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["environment"] = this.environment ? this.environment.toJSON() : undefined;
        data["defaultCuttoffDate"] = this.defaultCuttoffDate ? this.defaultCuttoffDate.toISOString() : undefined;
        if (Array.isArray(this.referenceKeyCuttoffs)) {
            data["referenceKeyCuttoffs"] = [];
            for (let item of this.referenceKeyCuttoffs)
                data["referenceKeyCuttoffs"].push(item.toJSON());
        }
        if (Array.isArray(this.overrides)) {
            data["overrides"] = [];
            for (let item of this.overrides)
                data["overrides"].push(item.toJSON());
        }
        data["retainedFromProductionDate"] = this.retainedFromProductionDate ? this.retainedFromProductionDate.toISOString() : undefined;
        return data;
    }
}
export class ReferenceKeyCuttoff {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.warpEnvironmentId = _data["warpEnvironmentId"];
            this.query = _data["query"];
            this.cuttoffDate = _data["cuttoffDate"] ? new Date(_data["cuttoffDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceKeyCuttoff();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["warpEnvironmentId"] = this.warpEnvironmentId;
        data["query"] = this.query;
        data["cuttoffDate"] = this.cuttoffDate ? this.cuttoffDate.toISOString() : undefined;
        return data;
    }
}
export class ListEnvironmentsByBuilderRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
            this.product = _data["product"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListEnvironmentsByBuilderRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        data["product"] = this.product;
        return data;
    }
}
export class ListNextPriorityConfigsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["priorityConfig"])) {
                this.priorityConfig = [];
                for (let item of _data["priorityConfig"])
                    this.priorityConfig.push(OrderedPriorityConfig.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListNextPriorityConfigsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.priorityConfig)) {
            data["priorityConfig"] = [];
            for (let item of this.priorityConfig)
                data["priorityConfig"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class PriorityConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.environmentName = _data["environmentName"];
            this.productName = _data["productName"];
            this.createRequestBodyJson = _data["createRequestBodyJson"];
            this.situApiCreateRequestBodyJson = _data["situApiCreateRequestBodyJson"];
            this.origin = _data["origin"];
            this.isOverridden = _data["isOverridden"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined;
            this.updatedBy = _data["updatedBy"];
            this.homeStatus = _data["homeStatus"];
            this.order = _data["order"];
            this.enabled = _data["enabled"];
            this.artifactId = _data["artifactId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PriorityConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["environmentName"] = this.environmentName;
        data["productName"] = this.productName;
        data["createRequestBodyJson"] = this.createRequestBodyJson;
        data["situApiCreateRequestBodyJson"] = this.situApiCreateRequestBodyJson;
        data["origin"] = this.origin;
        data["isOverridden"] = this.isOverridden;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : undefined;
        data["updatedBy"] = this.updatedBy;
        data["homeStatus"] = this.homeStatus;
        data["order"] = this.order;
        data["enabled"] = this.enabled;
        data["artifactId"] = this.artifactId;
        return data;
    }
}
export class OrderedPriorityConfig extends PriorityConfig {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.processingOrder = _data["processingOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderedPriorityConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["processingOrder"] = this.processingOrder;
        super.toJSON(data);
        return data;
    }
}
export var PriorityConfigOrigin;
(function (PriorityConfigOrigin) {
    PriorityConfigOrigin[PriorityConfigOrigin["UserAdded"] = 0] = "UserAdded";
    PriorityConfigOrigin[PriorityConfigOrigin["MostPopularHome"] = 1] = "MostPopularHome";
})(PriorityConfigOrigin || (PriorityConfigOrigin = {}));
export class ListNextPriorityConfigsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.numberOfJobsToRetrieve = _data["numberOfJobsToRetrieve"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListNextPriorityConfigsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["numberOfJobsToRetrieve"] = this.numberOfJobsToRetrieve;
        return data;
    }
}
export class PagedResponseOfPriorityConfig extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(PriorityConfig.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResponseOfPriorityConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}
export class ListPriorityConfigsResponse extends PagedResponseOfPriorityConfig {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriorityConfigsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class PagedRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PagedRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}
export class ListPriorityConfigsRequest extends PagedRequest {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["companyId"];
            this.homeStatus = _data["homeStatus"];
            this.productName = _data["productName"];
            this.environmentName = _data["environmentName"];
            this.isOverridden = _data["isOverridden"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListPriorityConfigsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["homeStatus"] = this.homeStatus;
        data["productName"] = this.productName;
        data["environmentName"] = this.environmentName;
        data["isOverridden"] = this.isOverridden;
        super.toJSON(data);
        return data;
    }
}
export class ListQueuedAssetModulesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["queuedAssetModules"])) {
                this.queuedAssetModules = [];
                for (let item of _data["queuedAssetModules"])
                    this.queuedAssetModules.push(QueuedAssetModule.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuedAssetModulesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queuedAssetModules)) {
            data["queuedAssetModules"] = [];
            for (let item of this.queuedAssetModules)
                data["queuedAssetModules"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListQueuedAssetModulesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.environmentName = _data["environmentName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuedAssetModulesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["environmentName"] = this.environmentName;
        return data;
    }
}
export class ListQueuedGenericArtifactsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["queuedGenericArtifacts"])) {
                this.queuedGenericArtifacts = [];
                for (let item of _data["queuedGenericArtifacts"])
                    this.queuedGenericArtifacts.push(QueuedGenericArtifact.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuedGenericArtifactsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queuedGenericArtifacts)) {
            data["queuedGenericArtifacts"] = [];
            for (let item of this.queuedGenericArtifacts)
                data["queuedGenericArtifacts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListQueuedGenericArtifactsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.environmentName = _data["environmentName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuedGenericArtifactsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["environmentName"] = this.environmentName;
        return data;
    }
}
export class ListQueuedSituFacadesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["queuedSituFacades"])) {
                this.queuedSituFacades = [];
                for (let item of _data["queuedSituFacades"])
                    this.queuedSituFacades.push(QueuedSituFacade.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuedSituFacadesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queuedSituFacades)) {
            data["queuedSituFacades"] = [];
            for (let item of this.queuedSituFacades)
                data["queuedSituFacades"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListQueuedSituFacadesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.environmentName = _data["environmentName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuedSituFacadesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["environmentName"] = this.environmentName;
        return data;
    }
}
export class ListQueuedSituPlansResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["queuedSituPlans"])) {
                this.queuedSituPlans = [];
                for (let item of _data["queuedSituPlans"])
                    this.queuedSituPlans.push(QueuedSituPlan.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuedSituPlansResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queuedSituPlans)) {
            data["queuedSituPlans"] = [];
            for (let item of this.queuedSituPlans)
                data["queuedSituPlans"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListQueuedSituPlansRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.environmentName = _data["environmentName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuedSituPlansRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["environmentName"] = this.environmentName;
        return data;
    }
}
export class ListQueuedSituRendersResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["queuedSituRenders"])) {
                this.queuedSituRenders = [];
                for (let item of _data["queuedSituRenders"])
                    this.queuedSituRenders.push(QueuedSituRender.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuedSituRendersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queuedSituRenders)) {
            data["queuedSituRenders"] = [];
            for (let item of this.queuedSituRenders)
                data["queuedSituRenders"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListQueuedSituRendersRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.environmentName = _data["environmentName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuedSituRendersRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["environmentName"] = this.environmentName;
        return data;
    }
}
export class ListQueuedSituVanitiesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["queuedSituVanities"])) {
                this.queuedSituVanities = [];
                for (let item of _data["queuedSituVanities"])
                    this.queuedSituVanities.push(QueuedSituVanity.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuedSituVanitiesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queuedSituVanities)) {
            data["queuedSituVanities"] = [];
            for (let item of this.queuedSituVanities)
                data["queuedSituVanities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListQueuedSituVanitiesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.environmentName = _data["environmentName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueuedSituVanitiesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["environmentName"] = this.environmentName;
        return data;
    }
}
export class ListRenderedHomesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["homeConfigs"])) {
                this.homeConfigs = [];
                for (let item of _data["homeConfigs"])
                    this.homeConfigs.push(HomeConfig.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRenderedHomesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.homeConfigs)) {
            data["homeConfigs"] = [];
            for (let item of this.homeConfigs)
                data["homeConfigs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListRenderedHomesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.builder = _data["builder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListRenderedHomesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["builder"] = this.builder;
        return data;
    }
}
export class ListSituFacadeConfigsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["configs"])) {
                this.configs = [];
                for (let item of _data["configs"])
                    this.configs.push(SituFacadeConfig.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListSituFacadeConfigsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.configs)) {
            data["configs"] = [];
            for (let item of this.configs)
                data["configs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class SituFacadeConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.dollyPercent = _data["dollyPercent"];
            this.focalPercent = _data["focalPercent"];
            this.imageWidth = _data["imageWidth"];
            this.imageHeight = _data["imageHeight"];
            this.imageQuality = _data["imageQuality"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituFacadeConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dollyPercent"] = this.dollyPercent;
        data["focalPercent"] = this.focalPercent;
        data["imageWidth"] = this.imageWidth;
        data["imageHeight"] = this.imageHeight;
        data["imageQuality"] = this.imageQuality;
        return data;
    }
}
export class ListSituFacadeConfigsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["facadeConfigNames"])) {
                this.facadeConfigNames = [];
                for (let item of _data["facadeConfigNames"])
                    this.facadeConfigNames.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListSituFacadeConfigsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facadeConfigNames)) {
            data["facadeConfigNames"] = [];
            for (let item of this.facadeConfigNames)
                data["facadeConfigNames"].push(item);
        }
        return data;
    }
}
export class ListSituRenderConfigsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["configs"])) {
                this.configs = [];
                for (let item of _data["configs"])
                    this.configs.push(SituRenderConfig.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListSituRenderConfigsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.configs)) {
            data["configs"] = [];
            for (let item of this.configs)
                data["configs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class SituRenderConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fingerPrint = _data["fingerPrint"];
            if (Array.isArray(_data["photos"])) {
                this.photos = [];
                for (let item of _data["photos"])
                    this.photos.push(SituRenderPhoto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituRenderConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fingerPrint"] = this.fingerPrint;
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item.toJSON());
        }
        return data;
    }
}
export class ListSituRenderConfigsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["fingerPrints"])) {
                this.fingerPrints = [];
                for (let item of _data["fingerPrints"])
                    this.fingerPrints.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListSituRenderConfigsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fingerPrints)) {
            data["fingerPrints"] = [];
            for (let item of this.fingerPrints)
                data["fingerPrints"].push(item);
        }
        return data;
    }
}
export class ListSituVanityOptionsConfigsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["optionsConfigs"])) {
                this.optionsConfigs = [];
                for (let item of _data["optionsConfigs"])
                    this.optionsConfigs.push(VanityOptionsConfig.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListSituVanityOptionsConfigsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.optionsConfigs)) {
            data["optionsConfigs"] = [];
            for (let item of this.optionsConfigs)
                data["optionsConfigs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class ListSituVanityOptionsConfigsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["fingerPrints"])) {
                this.fingerPrints = [];
                for (let item of _data["fingerPrints"])
                    this.fingerPrints.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListSituVanityOptionsConfigsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fingerPrints)) {
            data["fingerPrints"] = [];
            for (let item of this.fingerPrints)
                data["fingerPrints"].push(item);
        }
        return data;
    }
}
export class ListStyleChoicesResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["styleChoices"])) {
                this.styleChoices = [];
                for (let item of _data["styleChoices"])
                    this.styleChoices.push(StyleChoices.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListStyleChoicesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.styleChoices)) {
            data["styleChoices"] = [];
            for (let item of this.styleChoices)
                data["styleChoices"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class StyleChoices {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fingerprint = _data["fingerprint"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [];
                for (let item of _data["choices"])
                    this.choices.push(StyleChoice.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StyleChoices();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fingerprint"] = this.fingerprint;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data;
    }
}
export class ListStyleChoicesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["fingerPrints"])) {
                this.fingerPrints = [];
                for (let item of _data["fingerPrints"])
                    this.fingerPrints.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListStyleChoicesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fingerPrints)) {
            data["fingerPrints"] = [];
            for (let item of this.fingerPrints)
                data["fingerPrints"].push(item);
        }
        return data;
    }
}
export class AddEnvironmentOverrideResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.environmentOverrideId = _data["environmentOverrideId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddEnvironmentOverrideResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environmentOverrideId"] = this.environmentOverrideId;
        super.toJSON(data);
        return data;
    }
}
export class AddEnvironmentOverrideRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.warpEnvironmentId = _data["warpEnvironmentId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddEnvironmentOverrideRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["warpEnvironmentId"] = this.warpEnvironmentId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        return data;
    }
}
export class AddManyPriorityConfigsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["priorityConfigs"])) {
                this.priorityConfigs = [];
                for (let item of _data["priorityConfigs"])
                    this.priorityConfigs.push(PriorityConfig.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddManyPriorityConfigsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.priorityConfigs)) {
            data["priorityConfigs"] = [];
            for (let item of this.priorityConfigs)
                data["priorityConfigs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}
export class AddManyPriorityConfigsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["priorityConfigs"])) {
                this.priorityConfigs = [];
                for (let item of _data["priorityConfigs"])
                    this.priorityConfigs.push(AddPriorityConfig.fromJS(item));
            }
            this.removeAllConfigs = _data["removeAllConfigs"];
            this.removeCompletedConfigs = _data["removeCompletedConfigs"];
            this.productName = _data["productName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddManyPriorityConfigsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.priorityConfigs)) {
            data["priorityConfigs"] = [];
            for (let item of this.priorityConfigs)
                data["priorityConfigs"].push(item.toJSON());
        }
        data["removeAllConfigs"] = this.removeAllConfigs;
        data["removeCompletedConfigs"] = this.removeCompletedConfigs;
        data["productName"] = this.productName;
        return data;
    }
}
export class AddPriorityConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.createRequestBodyJson = _data["createRequestBodyJson"];
            this.situApiCreateRequestBodyJson = _data["situApiCreateRequestBodyJson"];
            this.origin = _data["origin"];
            this.isOverridden = _data["isOverridden"];
            this.order = _data["order"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddPriorityConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["createRequestBodyJson"] = this.createRequestBodyJson;
        data["situApiCreateRequestBodyJson"] = this.situApiCreateRequestBodyJson;
        data["origin"] = this.origin;
        data["isOverridden"] = this.isOverridden;
        data["order"] = this.order;
        return data;
    }
}
export class AddPriorityConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.priorityConfig = _data["priorityConfig"] ? PriorityConfig.fromJS(_data["priorityConfig"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddPriorityConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["priorityConfig"] = this.priorityConfig ? this.priorityConfig.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
}
export class AddPriorityConfigRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.priorityConfig = _data["priorityConfig"] ? AddPriorityConfig.fromJS(_data["priorityConfig"]) : undefined;
            this.productName = _data["productName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddPriorityConfigRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["priorityConfig"] = this.priorityConfig ? this.priorityConfig.toJSON() : undefined;
        data["productName"] = this.productName;
        return data;
    }
}
export class CopySituConnectResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.situConnectId = _data["situConnectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CopySituConnectResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situConnectId"] = this.situConnectId;
        super.toJSON(data);
        return data;
    }
}
export class CopySituConnectRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situConnectId = _data["situConnectId"];
            this.companyId = _data["companyId"];
            this.connectProductTypeCode = _data["connectProductTypeCode"];
            this.environment = _data["environment"];
            this.notifyCompleteChannel = _data["notifyCompleteChannel"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CopySituConnectRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situConnectId"] = this.situConnectId;
        data["companyId"] = this.companyId;
        data["connectProductTypeCode"] = this.connectProductTypeCode;
        data["environment"] = this.environment;
        data["notifyCompleteChannel"] = this.notifyCompleteChannel;
        return data;
    }
}
export var NotifyCompleteChannel;
(function (NotifyCompleteChannel) {
    NotifyCompleteChannel[NotifyCompleteChannel["None"] = 0] = "None";
    NotifyCompleteChannel[NotifyCompleteChannel["All"] = 1] = "All";
    NotifyCompleteChannel[NotifyCompleteChannel["Email"] = 2] = "Email";
    NotifyCompleteChannel[NotifyCompleteChannel["Teams"] = 3] = "Teams";
})(NotifyCompleteChannel || (NotifyCompleteChannel = {}));
export class CreateAssetModuleResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.assetModuleId = _data["assetModuleId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetModuleResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["assetModuleId"] = this.assetModuleId;
        super.toJSON(data);
        return data;
    }
}
export class CreateAssetModuleRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.assetModuleId = _data["assetModuleId"];
            this.assetModuleName = _data["assetModuleName"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.companyId = _data["companyId"];
            this.environment = _data["environment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetModuleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["assetModuleId"] = this.assetModuleId;
        data["assetModuleName"] = this.assetModuleName;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["companyId"] = this.companyId;
        data["environment"] = this.environment;
        return data;
    }
}
export class CreateGenericArtifactResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.status = _data["status"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGenericArtifactResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}
export class CreateGenericArtifactRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.companyId = _data["companyId"];
            this.environmentToUse = _data["environmentToUse"];
            this.environment = _data["environment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGenericArtifactRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["companyId"] = this.companyId;
        data["environmentToUse"] = this.environmentToUse;
        data["environment"] = this.environment;
        return data;
    }
}
export class CreateSituConnectResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["manufacturerCodesNotFound"])) {
                this.manufacturerCodesNotFound = [];
                for (let item of _data["manufacturerCodesNotFound"])
                    this.manufacturerCodesNotFound.push(item);
            }
            if (Array.isArray(_data["skuCodesNotFound"])) {
                this.skuCodesNotFound = [];
                for (let item of _data["skuCodesNotFound"])
                    this.skuCodesNotFound.push(item);
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [];
                for (let item of _data["warnings"])
                    this.warnings.push(item);
            }
            this.situConnectId = _data["situConnectId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituConnectResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.manufacturerCodesNotFound)) {
            data["manufacturerCodesNotFound"] = [];
            for (let item of this.manufacturerCodesNotFound)
                data["manufacturerCodesNotFound"].push(item);
        }
        if (Array.isArray(this.skuCodesNotFound)) {
            data["skuCodesNotFound"] = [];
            for (let item of this.skuCodesNotFound)
                data["skuCodesNotFound"].push(item);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        data["situConnectId"] = this.situConnectId;
        super.toJSON(data);
        return data;
    }
}
export class CreateSituFacadeResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.situFacadeId = _data["situFacadeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituFacadeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situFacadeId"] = this.situFacadeId;
        super.toJSON(data);
        return data;
    }
}
export class CreateSituFacadeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situFacadeId = _data["situFacadeId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            this.facadeConfigName = _data["facadeConfigName"];
            this.situFacadeConfig = _data["situFacadeConfig"] ? SituFacadeConfig.fromJS(_data["situFacadeConfig"]) : undefined;
            this.styleChoicesConfigName = _data["styleChoicesConfigName"];
            if (Array.isArray(_data["styleChoices"])) {
                this.styleChoices = [];
                for (let item of _data["styleChoices"])
                    this.styleChoices.push(StyleChoice.fromJS(item));
            }
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.companyId = _data["companyId"];
            this.environment = _data["environment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituFacadeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situFacadeId"] = this.situFacadeId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["facadeConfigName"] = this.facadeConfigName;
        data["situFacadeConfig"] = this.situFacadeConfig ? this.situFacadeConfig.toJSON() : undefined;
        data["styleChoicesConfigName"] = this.styleChoicesConfigName;
        if (Array.isArray(this.styleChoices)) {
            data["styleChoices"] = [];
            for (let item of this.styleChoices)
                data["styleChoices"].push(item.toJSON());
        }
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["companyId"] = this.companyId;
        data["environment"] = this.environment;
        return data;
    }
}
export class CreateSituFacadeWithConfigNamesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situFacadeId = _data["situFacadeId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            this.facadeConfigName = _data["facadeConfigName"];
            this.styleChoicesConfigName = _data["styleChoicesConfigName"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.companyId = _data["companyId"];
            this.environment = _data["environment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituFacadeWithConfigNamesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situFacadeId"] = this.situFacadeId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["facadeConfigName"] = this.facadeConfigName;
        data["styleChoicesConfigName"] = this.styleChoicesConfigName;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["companyId"] = this.companyId;
        data["environment"] = this.environment;
        return data;
    }
}
export class CreateSituFacadeWithIdsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situFacadeId = _data["situFacadeId"];
            this.homeConfigId = _data["homeConfigId"];
            this.facadeConfigName = _data["facadeConfigName"];
            this.styleChoicesConfigName = _data["styleChoicesConfigName"];
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.companyId = _data["companyId"];
            this.environment = _data["environment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituFacadeWithIdsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situFacadeId"] = this.situFacadeId;
        data["homeConfigId"] = this.homeConfigId;
        data["facadeConfigName"] = this.facadeConfigName;
        data["styleChoicesConfigName"] = this.styleChoicesConfigName;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["companyId"] = this.companyId;
        data["environment"] = this.environment;
        return data;
    }
}
export class CreateSituPlanResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.situPlanId = _data["situPlanId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituPlanResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situPlanId"] = this.situPlanId;
        super.toJSON(data);
        return data;
    }
}
export class CreateSituPlanRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situPlanId = _data["situPlanId"];
            this.homeConfig = _data["homeConfig"] ? HomeConfig.fromJS(_data["homeConfig"]) : undefined;
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.companyId = _data["companyId"];
            this.environment = _data["environment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituPlanRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situPlanId"] = this.situPlanId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["companyId"] = this.companyId;
        data["environment"] = this.environment;
        return data;
    }
}
export class CreateSituRenderResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.situRenderId = _data["situRenderId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituRenderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situRenderId"] = this.situRenderId;
        super.toJSON(data);
        return data;
    }
}
export class CreateSituRenderRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situRenderId = _data["situRenderId"];
            this.homeConfig = _data["homeConfig"] ? SituRenderHomeConfig.fromJS(_data["homeConfig"]) : undefined;
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["photos"])) {
                this.photos = [];
                for (let item of _data["photos"])
                    this.photos.push(SituRenderPhoto.fromJS(item));
            }
            this.environment = _data["environment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituRenderRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situRenderId"] = this.situRenderId;
        data["homeConfig"] = this.homeConfig ? this.homeConfig.toJSON() : undefined;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item.toJSON());
        }
        data["environment"] = this.environment;
        return data;
    }
}
export class SituRenderHomeConfig {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.home = _data["home"];
            this.masterFile = _data["masterFile"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (let item of _data["options"])
                    this.options.push(item);
            }
            if (Array.isArray(_data["themes"])) {
                this.themes = [];
                for (let item of _data["themes"])
                    this.themes.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SituRenderHomeConfig();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["home"] = this.home;
        data["masterFile"] = this.masterFile;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item);
        }
        return data;
    }
}
export class CreateSituVanityResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.situVanityId = _data["situVanityId"];
            this.status = _data["status"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituVanityResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situVanityId"] = this.situVanityId;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}
export class CreateSituVanityRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.situVanityId = _data["situVanityId"];
            this.vanityConfig = _data["vanityConfig"];
            this.vanityTheme = _data["vanityTheme"];
            this.vanityOptionsConfig = _data["vanityOptionsConfig"] ? VanityOptionsConfig.fromJS(_data["vanityOptionsConfig"]) : undefined;
            this.dateRequestedFor = _data["dateRequestedFor"] ? new Date(_data["dateRequestedFor"].toString()) : undefined;
            this.companyId = _data["companyId"];
            this.environment = _data["environment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSituVanityRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["situVanityId"] = this.situVanityId;
        data["vanityConfig"] = this.vanityConfig;
        data["vanityTheme"] = this.vanityTheme;
        data["vanityOptionsConfig"] = this.vanityOptionsConfig ? this.vanityOptionsConfig.toJSON() : undefined;
        data["dateRequestedFor"] = this.dateRequestedFor ? this.dateRequestedFor.toISOString() : undefined;
        data["companyId"] = this.companyId;
        data["environment"] = this.environment;
        return data;
    }
}
export class DeleteEnvironmentOverrideResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEnvironmentOverrideResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class DeleteEnvironmentOverrideRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.environmentOverrideId = _data["environmentOverrideId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEnvironmentOverrideRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environmentOverrideId"] = this.environmentOverrideId;
        return data;
    }
}
export class DownloadSituFacadesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["facadeIds"])) {
                this.facadeIds = [];
                for (let item of _data["facadeIds"])
                    this.facadeIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadSituFacadesRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.facadeIds)) {
            data["facadeIds"] = [];
            for (let item of this.facadeIds)
                data["facadeIds"].push(item);
        }
        return data;
    }
}
export class PurgeCacheResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PurgeCacheResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class PurgeCacheRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.keyPrefix = _data["keyPrefix"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PurgeCacheRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["keyPrefix"] = this.keyPrefix;
        return data;
    }
}
export class RemoveManyPriorityConfigResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.priorityConfigsRemovedCount = _data["priorityConfigsRemovedCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveManyPriorityConfigResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["priorityConfigsRemovedCount"] = this.priorityConfigsRemovedCount;
        super.toJSON(data);
        return data;
    }
}
export class RemoveManyPriorityConfigsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["priorityConfigIdsToRemove"])) {
                this.priorityConfigIdsToRemove = [];
                for (let item of _data["priorityConfigIdsToRemove"])
                    this.priorityConfigIdsToRemove.push(item);
            }
            this.productName = _data["productName"];
            this.removeAllConfigs = _data["removeAllConfigs"];
            this.removeCompletedConfigs = _data["removeCompletedConfigs"];
            this.isOverridden = _data["isOverridden"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveManyPriorityConfigsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.priorityConfigIdsToRemove)) {
            data["priorityConfigIdsToRemove"] = [];
            for (let item of this.priorityConfigIdsToRemove)
                data["priorityConfigIdsToRemove"].push(item);
        }
        data["productName"] = this.productName;
        data["removeAllConfigs"] = this.removeAllConfigs;
        data["removeCompletedConfigs"] = this.removeCompletedConfigs;
        data["isOverridden"] = this.isOverridden;
        return data;
    }
}
export class ReorderPriorityConfigsResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderPriorityConfigsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class ReorderPriorityConfigsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.productName = _data["productName"];
            if (_data["priorityConfigOrders"]) {
                this.priorityConfigOrders = {};
                for (let key in _data["priorityConfigOrders"]) {
                    if (_data["priorityConfigOrders"].hasOwnProperty(key))
                        this.priorityConfigOrders[key] = _data["priorityConfigOrders"][key];
                }
            }
            this.moveToOrder = _data["moveToOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderPriorityConfigsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["productName"] = this.productName;
        if (this.priorityConfigOrders) {
            data["priorityConfigOrders"] = {};
            for (let key in this.priorityConfigOrders) {
                if (this.priorityConfigOrders.hasOwnProperty(key))
                    data["priorityConfigOrders"][key] = this.priorityConfigOrders[key];
            }
        }
        data["moveToOrder"] = this.moveToOrder;
        return data;
    }
}
export class SaveEnvironmentsForBuilderResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEnvironmentsForBuilderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SaveEnvironmentsForBuilderRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["environments"])) {
                this.environments = [];
                for (let item of _data["environments"])
                    this.environments.push(EnvironmentSettings.fromJS(item));
            }
            this.clearOverrides = _data["clearOverrides"];
            if (Array.isArray(_data["artifactsToRetain"])) {
                this.artifactsToRetain = [];
                for (let item of _data["artifactsToRetain"])
                    this.artifactsToRetain.push(ArtifactVersion.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEnvironmentsForBuilderRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.environments)) {
            data["environments"] = [];
            for (let item of this.environments)
                data["environments"].push(item.toJSON());
        }
        data["clearOverrides"] = this.clearOverrides;
        if (Array.isArray(this.artifactsToRetain)) {
            data["artifactsToRetain"] = [];
            for (let item of this.artifactsToRetain)
                data["artifactsToRetain"].push(item.toJSON());
        }
        return data;
    }
}
export class SaveRenderErrorRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactToCreate = _data["artifactToCreate"];
            if (Array.isArray(_data["baseIngredients"])) {
                this.baseIngredients = [];
                for (let item of _data["baseIngredients"])
                    this.baseIngredients.push(ArtifactVersionReference.fromJS(item));
            }
            this.artifactId = _data["artifactId"];
            this.errorMessage = _data["errorMessage"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRenderErrorRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactToCreate"] = this.artifactToCreate;
        if (Array.isArray(this.baseIngredients)) {
            data["baseIngredients"] = [];
            for (let item of this.baseIngredients)
                data["baseIngredients"].push(item.toJSON());
        }
        data["artifactId"] = this.artifactId;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}
export class ArtifactVersionReference {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
            this.path = _data["path"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactVersionReference();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        data["path"] = this.path;
        return data;
    }
}
export class SetArtifactAsProductionResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetArtifactAsProductionResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SetArtifactAsProductionRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artifactId = _data["artifactId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetArtifactAsProductionRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artifactId"] = this.artifactId;
        return data;
    }
}
export class SetPriorityConfigStatusResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetPriorityConfigStatusResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class SetPriorityConfigStatusRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.environment = _data["environment"];
            this.productName = _data["productName"];
            this.enabled = _data["enabled"];
            this.homeStatus = _data["homeStatus"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SetPriorityConfigStatusRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["environment"] = this.environment;
        data["productName"] = this.productName;
        data["enabled"] = this.enabled;
        data["homeStatus"] = this.homeStatus;
        return data;
    }
}
export class UpdateEnvironmentOverrideResponse extends SituResponse {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnvironmentOverrideResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}
export class UpdateEnvironmentOverrideRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.environmentOverrideId = _data["environmentOverrideId"];
            this.callerReferenceKey = _data["callerReferenceKey"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnvironmentOverrideRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["environmentOverrideId"] = this.environmentOverrideId;
        data["callerReferenceKey"] = this.callerReferenceKey;
        data["version"] = this.version;
        return data;
    }
}
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
